import script from "./Examination.vue?vue&type=script&setup=true&lang=js"
export * from "./Examination.vue?vue&type=script&setup=true&lang=js"

import "./Examination.vue?vue&type=style&index=0&id=ed9d8974&scoped=true&lang=less"

import exportComponent from "/Users/user/mscode/tecs/TECS-FE-ENDUSER-NEW/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed9d8974"]])

export default __exports__